import { ENV } from '../config/env';

interface CompanyLogoOptions {
  size?: number;
  format?: 'jpg' | 'png' | 'webp';
  theme?: 'auto' | 'light' | 'dark';
  retina?: boolean;
  fallback?: 'monogram' | 404;
}

export function companyLogoUrl(name: string, options: CompanyLogoOptions = {}): string {
  const { size = 128, format = 'webp', theme = 'dark', retina = true, fallback } = options;
  const params = new URLSearchParams({ token: ENV.LOGO_DEV_TOKEN, size: String(size), format, theme });
  if (retina) params.set('retina', 'true');
  if (fallback === 404) params.set('fallback', '404');
  return `https://img.logo.dev/name/${encodeURIComponent(name)}?${params.toString()}`;
}

export function domainLogoUrl(domain: string, options: CompanyLogoOptions = {}): string {
  const { size = 128, format = 'webp', theme = 'dark', retina = true, fallback } = options;
  const params = new URLSearchParams({ token: ENV.LOGO_DEV_TOKEN, size: String(size), format, theme });
  if (retina) params.set('retina', 'true');
  if (fallback === 404) params.set('fallback', '404');
  return `https://img.logo.dev/${encodeURIComponent(domain)}?${params.toString()}`;
}

export type LogoSourceType = 'logodev_name' | 'logodev_domain' | 'custom';

export function brandLogoSrc(type: LogoSourceType | string | null | undefined, value: string | null | undefined, fallbackName: string): string {
  const cleanValue = value?.trim();
  if (type === 'custom' && cleanValue) return cleanValue;
  if (type === 'logodev_domain' && cleanValue) return domainLogoUrl(cleanValue, { theme: 'light' });
  return companyLogoUrl(cleanValue || fallbackName, { theme: 'light' });
}
